import { reactive, watch } from "vue";
import { useRoute } from "vue-router";
import { useActiveMenu } from "./useActiveMenu";

/**
 * @composable useMenuAutoExpand
 * @description A ogni cambio di route apre i gruppi del menu che contengono la pagina corrente e chiude
 * gli altri (anche quando si arriva da un link esterno alla sidebar, es. quick connect della homepage).
 * Agisce sul flag `open` delle voci di menu.json, condiviso da MenuDesktop e MenuMobile; i click manuali
 * sui gruppi continuano a funzionare fino al cambio di pagina successivo.
 *
 * @param {Array} menuItems - voci di primo livello di src/configs/menu.json
 */
export function useMenuAutoExpand(menuItems) {
  const route = useRoute();
  const { isItemActive } = useActiveMenu(menuItems);
  // stesso proxy reattivo di data().menu nei componenti: le modifiche aggiornano il template
  const menu = reactive(menuItems);

  function syncOpen(items) {
    items.forEach((item) => {
      if (!item.child) return;
      item.open = isItemActive(item);
      syncOpen(item.child);
    });
  }

  watch(() => route.path, () => syncOpen(menu), { immediate: true });
}
